import EventDispatcher from "../../../../../shared/lib/html5-software-library/src/ranj/util/EventDispatcher";

export default class TutorialStep extends EventDispatcher {
    constructor() {
        super();

        this._onEnter = null;
        this._onComplete = null;
    }

    destroy() {
        this._onEnter = null;
        this._onComplete = null;

        this.removeAllEventListeners();
    }

    get onEnter() {
        return this._onEnter;
    }

    set onEnter(value) {
        this._onEnter = value;
    }

    get onComplete() {
        return this._onComplete;
    }

    set onComplete(value) {
        this._onComplete = value;
    }

    enter() {
        if (this.onEnter) {
            this._onEnter.call(this);
        }
    }

    complete() {
        if (this.onComplete) {
            this._onComplete.call(this);
        }
        this.dispatchEvent(TutorialStep.COMPLETED);

        this._onEnter = null;
        this._onComplete = null;
    }
}

TutorialStep.COMPLETED = "completed";